import {override} from "mobx";
import {APP} from "../../../../../core/app/consts";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {GameCenterTabModel} from "./game-center.tab-model";

export class GameCenterPointByPointTabModel extends GameCenterTabModel {
  @override get isVisible(): Boolean {
    return this.entity.hasPointByPoint;
  }

  get eventName(): String {
    return null
  }

  get eventParams(): Object {
    const eventParams = {
      gameId: this.entity.id,
      entityId: this.entity.id,
      status: this.entity.statusGroup,
      source: APP.ANALYTICS.SOURCES.gameCenterTabs,
    }

    return eventParams;
  }

  get hasIcon(): Boolean {
    return false;
  }

  get isNoFollow(): Boolean {
    return true;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.pointByPoint;
  }

  get elementId(): String {
    return 'navigation-tabs_game-center_point_by_point';
  }
}
